/**
 * Converts a date to a formatted string.
 *
 * @param date - The input date to be formatted.
 * @param options - The formatting options.
 * @param locale - The locale to use for formatting.
 * @returns Formatted date string.
 *
 * @example
 * toFormattedDateString(new Date(), { year: 'numeric', month: '2-digit', day: '2-digit' }, 'en-GB'); // Output: '01/01/2022'
 * toFormattedDateString(new Date(), { year: 'numeric', month: 'long', day: 'numeric' }, 'en-GB'); // Output: 'January 1, 2022'
 * toFormattedDateString(new Date(), { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false }, 'en-GB'); // Output: 'January 1, 2022, 00:00'
 */
export function toFormattedDateString(
	date: string | Date,
	options: Intl.DateTimeFormatOptions = {
		year: 'numeric',
		month: '2-digit',
		day: '2-digit',
		hour: '2-digit',
		minute: '2-digit',
		hour12: false,
	},
	locale: string = 'en-GB',
): string {
	const dateTime = typeof date === 'string' ? new Date(date) : date;

	return dateTime.toLocaleString(locale, options).replace(',', '');
}
